<header class="header">
  <div class="header-content">
    <div class="welcome-text">{{title}}</div>
    <div class="dropdown" (click)="toggleDropdown($event)">
      <button class="dropdown-toggle">
        Welcome {{ username }}
      </button>
      
      <div class="dropdown-menu" [class.active]="isDropdownOpen">
        <a href="/admin/dashboard" class="dropdown-item" *ngIf="isAdministrator">Administration</a>
        <a href="/admin/golfcourses" class="dropdown-item" *ngIf="isAdministrator">Golf Courses</a>
        <a href="#" class="dropdown-item" (click)="logout()">Sign Out</a>
      </div>
    </div>
  </div>
</header>

<div class="content-wrapper">
  <router-outlet></router-outlet>
</div>

<nav class="bottom-nav">
  <div class="bottom-nav-content">
    <a href="/home" class="nav-item">
      <div class="nav-icon">🏠</div>
      <div class="nav-label">Home</div>
    </a>
    <a href="practice" class="nav-item">
      <div class="nav-icon">⛳</div>
      <div class="nav-label">Practice</div>
    </a>
    <a href="/review" class="nav-item">
      <div class="nav-icon">📋</div>
      <div class="nav-label">Review</div>
    </a>
    <a href="/setup" class="nav-item">
      <div class="nav-icon">🏆</div>
      <div class="nav-label">Setup</div>
    </a>
  </div>
</nav>


  <div *ngIf="isBusy" class="spinner-overlay">
    <img src="../assets/noun-loader-3784345-FFFFFF.png" class="spinner" />
  </div> 